import ReactDOM from "react-dom/client";
import App from "./App";
import {StrictMode} from "react";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<div style={{maxWidth: "100%"}}>
		{
			process.env.NODE_ENV === "development"? <StrictMode><App/></StrictMode> : <App/>
		}
	</div>
);

